import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../SidebarItem";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../SidebarContext";

RetailerProfileItem.propTypes = {
    retailerId: PropTypes.string.isRequired
};

function RetailerProfileItem({retailerId}) {
    const {currentPath, currentMemberAuthorizations, isUserAdmin} = useContext(SidebarContext);

    if (isUserAdmin || !hasAuthorization(currentMemberAuthorizations, Authorizations.OTHER_RETAILER_PROFILE)) {
        return null;
    }

    return (
        <SidebarItem
            to={MarketplaceRoutes.RETAILER_PROFILE(retailerId)}
            selected={currentPath === MarketplaceRoutes.RETAILER_PROFILE(retailerId)}
        >
            <FormattedMessage id='sidebar.item.retailerProfiles' />
        </SidebarItem>
    );
}

export default RetailerProfileItem;
